<template>
  <a-modal
    :title="title === '1' ? $t('add') : $t('edit')"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('close')"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;overflow-y: hidden">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'taskName')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'taskName')" v-decorator="[ 'taskName', validatorRules.taskName]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'taskChannel')">
          <a-select v-decorator="[ 'channel', validatorRules.channel]" :placeholder="$t('select') + ' ' + $t(I18N_KEY + 'taskChannel')">
            <a-select-option v-for='item in channels' :key='item'>
              {{item}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'strategyId')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'strategyId')" v-decorator="[ 'strategyId', validatorRules.strategyId]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'thirdTaskId')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'thirdTaskId')" v-decorator="[ 'thirdTaskId', validatorRules.thirdTaskId]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'connectNotCall')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'connectNotCall')" v-decorator="[ 'connectNotCall', validatorRules.connectNotCall, { initialValue: '0' }]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'convertNotCall')">
          <a-select v-decorator="[ 'convertNotCall', validatorRules.convertNotCall]" :placeholder="$t('select') + ' ' + $t(I18N_KEY + 'convertNotCall')">
            <a-select-option v-for='item in convertNotCalls' :key='item'>
              {{$t(I18N_KEY + 'convertNotCall_'+item)}}
<!--              {{item}}-->
            </a-select-option>
          </a-select>
<!--          <a-radio-group-->
<!--            v-decorator="['convertNotCall', validatorRules.convertNotCall]">-->
<!--            <span v-for="item in convertNotCalls">-->
<!--              <a-radio :value=item>{{ $t(I18N_KEY + 'convertNotCall_'+item) }}</a-radio>-->
<!--            </span>-->
<!--          </a-radio-group>-->
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'accessKeys')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'accessKeys')" v-decorator="[ 'accessKeys', validatorRules.accessKeys]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'taskIds')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'taskIds')" v-decorator="[ 'taskIds', validatorRules.taskIds]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'taskStatus')">
          <a-radio-group
            v-decorator="['status', validatorRules.status]">
            <span v-for="item in statuses">
              <a-radio :value=item.value>{{ item[fieldName] }}</a-radio>
            </span>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
const I18N_KEY = 'teleMarket.';
export default {
  name: "SeatModal",
  props: {
    channels: {
      type: Array,
      default: () => [],
    },
    statuses: {
      type: Array,
      default: () => [],
    },
    convertNotCalls: {
      type: Array,
      default: () => [],
    },
    fieldName: {
      type: String,
      default: () => 'textCn',
    }
  },
  data () {
    return {
      I18N_KEY,
      title:"Action",
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules:{
        taskName:{
          rules: [
            { required: true, message: 'Please input taskName!' },
          ]},
        channel:{
          rules: [
            { required: true, message: 'Please select channel!' },
          ]},
        status:{
          rules: [
            { required: true, message: 'Please select status!' },
          ]},
        strategyId:{
          rules: [
            { required: false },
          ]},
        thirdTaskId:{
          rules: [
            { required: false },
          ]},
        accessKeys:{
          rules: [
            { required: true, message: 'Please input accessKeys!' },
          ]},
        taskIds:{
          rules: [
            { required: false },
          ]},
        connectNotCall:{
          rules: [
            { required: true, message: 'Please input connectNotCall!'},
          ]},
        convertNotCall:{
          rules: [
            { required: true, message: 'Please select convertNotCall!' },
          ]},
      },
    }
  },
  created () {
  },
  methods: {
    add () {
      this.edit({});
    },
    edit (record) {
      this.form.resetFields();
      this.open();
      this.model = Object.assign({}, record)
      this.model = {
        ...this.model,
        status: this.model.status != undefined ? '' + this.model.status : '1',
        connectNotCall: this.model.connectNotCall != undefined ? this.model.connectNotCall : 0,
        // convertNotCall: this.model.convertNotCall != undefined ? '' + this.model.convertNotCall : '1',
      }

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'taskName', 'channel', 'status', 'strategyId','thirdTaskId','connectNotCall','convertNotCall','accessKeys','taskIds'))
      });

    },
    open () {
      this.visible = true;
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    openLoading () {
      this.confirmLoading = true;
    },
    closeLoading () {
      this.confirmLoading = false;
    },
    handleOk () {
      // console.log(88888)
      const that = this;
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = {
            ...values,
          }
          this.$emit('ok', formData);

        }
      })
    },
    handleCancel () {
      this.close()
    },
  }
}
</script>

<style scoped>

</style>